import React from "react";
import { Form } from "antd";
import { useTranslate } from "@refinedev/core";
import { Grid } from "@libertify/ui";
// import { Toggle } from "@libertify/ui"; // re-enable with the hidden toggles below
import { PlaybookAddOnCard } from "../../PlaybookAddOnCard";
import { PlaybookInput } from "../../PlaybookInput";
import { PlaybookSelect } from "../../PlaybookSelect";
import { PlaybookFormItem } from "../../PlaybookFormItem";
import { normalizeNumericInput } from "../../../helpers";
import { useAddonDraft } from "../../../context/PlaybookDraftContext";
import { QuickRecallFormValues } from "../types";
import { QUICK_RECALL_DEFAULTS } from "../defaults";
import { CONFIG_ITEM } from "../../../data/addons";

// TODO: replace with a real credit estimate once the backend exposes one for
// this add-on. Hardcoded for now
const ESTIMATED_CREDITS = 90;

export const QuickRecallConfigCard: React.FC = () => {
  const t = useTranslate();
  const [form] = Form.useForm<QuickRecallFormValues>();
  // The draft key is the backend `Flashcards` add-on type (kept as the wire
  // value); only the display name is "Quick recall".
  const { initialValues, onValuesChange } = useAddonDraft(
    CONFIG_ITEM.Flashcards,
    QUICK_RECALL_DEFAULTS
  );

  // Option values are the API `ItemOrder` enum so the stored form value needs
  // no translation.
  const cardOrderOptions = [
    {
      value: "Sequential",
      label: t("createExperience.addOns.quickRecall.cardOrder.sequential"),
    },
    {
      value: "Random",
      label: t("createExperience.addOns.quickRecall.cardOrder.shuffle"),
    },
  ];

  // Hidden for now — re-enable together with the answerFormat form item below.
  // const answerFormatOptions = [
  //   {
  //     value: "shortAnswer",
  //     label: t("createExperience.addOns.quickRecall.answerFormat.shortAnswer"),
  //   },
  //   {
  //     value: "answerExplanation",
  //     label: t(
  //       "createExperience.addOns.quickRecall.answerFormat.answerExplanation"
  //     ),
  //   },
  //   {
  //     value: "answerExample",
  //     label: t("createExperience.addOns.quickRecall.answerFormat.answerExample"),
  //   },
  //   {
  //     value: "answerCommonMistake",
  //     label: t(
  //       "createExperience.addOns.quickRecall.answerFormat.answerCommonMistake"
  //     ),
  //   },
  // ];

  return (
    <PlaybookAddOnCard
      itemId={CONFIG_ITEM.Flashcards}
      title={t("createExperience.addOns.quickRecall.title")}
      credits={ESTIMATED_CREDITS}
      description={t("createExperience.addOns.quickRecall.description")}
    >
      <Form<QuickRecallFormValues>
        form={form}
        layout="vertical"
        initialValues={initialValues}
        onValuesChange={onValuesChange}
      >
        <Grid columns={2} gap="lg">
          <PlaybookFormItem
            name={["generation_settings", "nb_of_cards"]}
            labelKey="createExperience.addOns.quickRecall.cardsPerSession"
            normalize={normalizeNumericInput}
          >
            <PlaybookInput type="number" min={1} />
          </PlaybookFormItem>
          <PlaybookFormItem
            name={["functional_settings", "card_order"]}
            labelKey="createExperience.addOns.quickRecall.cardOrder.label"
          >
            <PlaybookSelect options={cardOrderOptions} />
          </PlaybookFormItem>

          {/* Hidden for now — re-enable together with their
              QUICK_RECALL_DEFAULTS entries, the answerFormatOptions list and
              the Toggle import above. */}
          {/* <PlaybookFormItem
            name="answerFormat"
            labelKey="createExperience.addOns.quickRecall.answerFormat.label"
          >
            <PlaybookSelect options={answerFormatOptions} />
          </PlaybookFormItem>
          <PlaybookFormItem
            name="showHints"
            labelKey="createExperience.addOns.quickRecall.showHints"
            valuePropName="checked"
          >
            <Toggle size="l" />
          </PlaybookFormItem>

          <PlaybookFormItem
            name="reviewSummary"
            labelKey="createExperience.addOns.quickRecall.reviewSummary"
            valuePropName="checked"
          >
            <Toggle size="l" />
          </PlaybookFormItem> */}
        </Grid>
      </Form>
    </PlaybookAddOnCard>
  );
};

export default QuickRecallConfigCard;
